import { render, staticRenderFns } from "./TestAnswerItem.vue?vue&type=template&id=724797cc&"
import script from "./TestAnswerItem.vue?vue&type=script&lang=js&"
export * from "./TestAnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./TestAnswerItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports